export default __webpack_public_path__ + "static/media/Proceedix.316dac27.png";